module.exports = __webpack_public_path__ + "static/media/star_tall_240ce.5613eb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/climasense/phythophtora_cinnamomi/curativa/star_tall_240ce.png
// module id = 2296
// module chunks = 3